module.exports = __webpack_public_path__ + "img/google-ads-app.d46e9dbe.svg";